import { CheckPriceProduct } from "app/models/product/check-price-product/check-price-product";

export class CheckPriceOrder {

  paymentReceiptForm: number;
  receivingCondition: number;

  constructor(paymentReceiptForm: number, receivingCondition: number) {
    this.paymentReceiptForm = paymentReceiptForm ?? null;
    this.receivingCondition = receivingCondition ?? null;
  }

}
